import { c as _c } from "react/compiler-runtime";
import { arrayMove } from '@dnd-kit/sortable';
import { AddIcon } from '@systemeio/ui/icons';
import { FormInput, Modal, ModalSizeEnum, PrimaryButton, SecondaryButton } from '@systemeio/ui';
import { StageItem } from 'modules/crm/components/stage-item';
import { PipelineErrorsInterface } from 'modules/crm/pipeline/type/pipeline-errors-interface';
import { PipelineCreateStageInterface, PipelineEditInterface } from 'modules/crm/types/pipeline-interface';
import React, { Dispatch, SetStateAction } from 'react';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import Sortable from 'shared/components/sortable';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface PipelineUpdateBodyProps {
  tempState: PipelineEditInterface;
  setTempState: Dispatch<SetStateAction<PipelineEditInterface>>;
  errors: PipelineErrorsInterface;
  isUpdate: boolean;
  isOpened: boolean;
  onClose: () => void;
  afterLeave: () => void;
  saveCrmPipeline: () => void;
  modalTitle: string;
  withConfirmation?: boolean;
}
export const PipelineUpdateBody = t0 => {
  const $ = _c(76);
  const {
    tempState,
    setTempState,
    errors,
    withConfirmation,
    isUpdate,
    onClose,
    afterLeave,
    saveCrmPipeline,
    modalTitle,
    isOpened
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== setTempState || $[1] !== tempState.stages) {
    t1 = () => {
      const lastItem = tempState.stages.at(-1);
      if (lastItem) {
        setTempState(prevState => ({
          ...prevState,
          stages: [...prevState.stages, {
            name: "",
            position: lastItem.position + 1
          }]
        }));
      }
    };
    $[0] = setTempState;
    $[1] = tempState.stages;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const createNewStage = t1;
  let t2;
  if ($[3] !== errors || $[4] !== setTempState || $[5] !== tempState.stages.length || $[6] !== withConfirmation) {
    t2 = (stage, index) => <StageItem stage={stage} setTempState={setTempState} key={`stage-${stage.position}`} showBin={tempState.stages.length > 2} withConfirmation={withConfirmation} error={index ? errors.fields[`stages[${index}]`] || errors.fields[`stages[${index}].name`] : undefined} />;
    $[3] = errors;
    $[4] = setTempState;
    $[5] = tempState.stages.length;
    $[6] = withConfirmation;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const getStageItem = t2;
  let t3;
  if ($[8] !== setTempState || $[9] !== tempState.stages) {
    t3 = async (activeIndex, overIndex) => {
      const reorderedStages = arrayMove(tempState.stages, activeIndex, overIndex);
      setTempState(prevState_0 => ({
        ...prevState_0,
        stages: reorderedStages
      }));
    };
    $[8] = setTempState;
    $[9] = tempState.stages;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const onMove = t3;
  let t4;
  if ($[11] !== t) {
    t4 = t("global.name");
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t) {
    t5 = t("dashboard.crm_pipeline.modal.pipeline_name");
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = tempState?.name;
  let t7;
  if ($[15] !== setTempState) {
    t7 = e => setTempState(prev => prev && {
      ...prev,
      name: e.target.value
    });
    $[15] = setTempState;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const t8 = errors?.fields?.name;
  let t9;
  if ($[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t9 = <FormInput placeholder={t4} label={t5} value={t6} onChange={t7} className="mb-8" error={t8} />;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t) {
    t10 = t("dashboard.crm_pipeline.modal.pipeline_statuses");
    $[23] = t;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10) {
    t11 = <span className="text-text-primary text-[20px] font-semibold">{t10}</span>;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== createNewStage) {
    t12 = <AddIcon className="fill-brand-primary h-[24px] w-[24px] cursor-pointer" onClick={() => createNewStage()} />;
    $[27] = createNewStage;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t11 || $[30] !== t12) {
    t13 = <div className="mb-5 flex items-center justify-between">{t11}{t12}</div>;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== tempState.stages) {
    t14 = tempState.stages.map(_temp);
    $[32] = tempState.stages;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== onMove) {
    t15 = (_, activeIndex_0, overIndex_0) => onMove(activeIndex_0, overIndex_0);
    $[34] = onMove;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== getStageItem || $[37] !== tempState.stages) {
    t16 = tempState.stages.map(getStageItem);
    $[36] = getStageItem;
    $[37] = tempState.stages;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== getStageItem || $[40] !== t14 || $[41] !== t15 || $[42] !== t16) {
    t17 = <div className="customScroll max-h-[200px] overflow-y-auto md:max-h-[350px]"><Sortable draggable={getStageItem} items={t14} onMove={t15} isPortal={true}>{t16}</Sortable></div>;
    $[39] = getStageItem;
    $[40] = t14;
    $[41] = t15;
    $[42] = t16;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== t13 || $[45] !== t17) {
    t18 = <div>{t13}{t17}</div>;
    $[44] = t13;
    $[45] = t17;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== t) {
    t19 = t("global.cancel");
    $[47] = t;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== isUpdate || $[50] !== onClose || $[51] !== t19) {
    t20 = <SecondaryButton disabled={isUpdate} onClick={onClose} width="large">{t19}</SecondaryButton>;
    $[49] = isUpdate;
    $[50] = onClose;
    $[51] = t19;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  let t21;
  if ($[53] !== t) {
    t21 = t("global.save");
    $[53] = t;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== isUpdate || $[56] !== saveCrmPipeline || $[57] !== t21) {
    t22 = <PrimaryButton isFetching={isUpdate} onClick={saveCrmPipeline} width="large">{t21}</PrimaryButton>;
    $[55] = isUpdate;
    $[56] = saveCrmPipeline;
    $[57] = t21;
    $[58] = t22;
  } else {
    t22 = $[58];
  }
  let t23;
  if ($[59] !== t20 || $[60] !== t22) {
    t23 = <div className="mt-3 flex justify-end gap-3">{t20}{t22}</div>;
    $[59] = t20;
    $[60] = t22;
    $[61] = t23;
  } else {
    t23 = $[61];
  }
  let t24;
  if ($[62] !== errors?.common) {
    t24 = errors?.common?.join(", ");
    $[62] = errors?.common;
    $[63] = t24;
  } else {
    t24 = $[63];
  }
  let t25;
  if ($[64] !== t24) {
    t25 = <FieldErrorAndDescription error={t24} errorClassName="text-center pt-2" />;
    $[64] = t24;
    $[65] = t25;
  } else {
    t25 = $[65];
  }
  let t26;
  if ($[66] !== afterLeave || $[67] !== isOpened || $[68] !== isUpdate || $[69] !== modalTitle || $[70] !== onClose || $[71] !== t18 || $[72] !== t23 || $[73] !== t25 || $[74] !== t9) {
    t26 = <Modal size={ModalSizeEnum.medium} opened={isOpened} afterLeave={afterLeave} isFetching={isUpdate} onClose={onClose} title={modalTitle}>{t9}{t18}{t23}{t25}</Modal>;
    $[66] = afterLeave;
    $[67] = isOpened;
    $[68] = isUpdate;
    $[69] = modalTitle;
    $[70] = onClose;
    $[71] = t18;
    $[72] = t23;
    $[73] = t25;
    $[74] = t9;
    $[75] = t26;
  } else {
    t26 = $[75];
  }
  return t26;
};
function _temp(item) {
  return {
    ...item,
    id: item.position
  };
}